import mitt from "mitt";

const emitter = mitt();

let lastValues = {
  voltage: 0,
  current: 0,
  power: 0,
};

// Stav zariadení
const deviceStatusStore = {};

export default emitter;

// ----- Práca s poslednými hodnotami -----
export function setLastValues(values) {
  lastValues = values;
}
export function getLastValues() {
  return lastValues;
}

// ----- Práca so stavom zariadení -----
export function setDeviceStatus(device, status) {
  deviceStatusStore[device] = status;
}
export function getDeviceStatus(device) {
  return deviceStatusStore[device];
}
export function getAllDeviceStatuses() {
  return { ...deviceStatusStore }; // shallow copy
}